{
  "longPressMessage": "Pulse para abrir la vista previa"
}
